import getColor from "@insite/mobius/utilities/getColor";
import WarningHarmful from "@waytek/MobiusOverrides/Icons/WarningHarmful";
import { specificationsStyles as styles } from "@waytek/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.harmfulWrapper = {
    css: css`
        display: inline-flex;

        ${mediaQueriesBP.maxMD} {
            margin-top: 20px;
        }

        ${mediaQueriesBP.minMD} {
            margin-top: 33px;
        }
    `,
};

styles.harmfulIcon = {
    src: WarningHarmful,
    size: 24,
    color: colorStrings.commonGlobalBlack,
    css: css`
        margin-right: 5px;

        .icon-background {
            fill: ${getColor(colorStrings.uiWarning)};
        }
    `,
};

styles.harmfulLabel = {
    size: "14px",
    lineHeight: "24px",
};
